import React from 'react';
import { CustomButton } from '../../../../shared/customButton';
import styles from './specialNoteReview.module.scss';
import { Container, Row, Col } from 'react-bootstrap';

function SpecialNoteReview(props) {

    return (
        <div>
            <Container>
                <Row className={styles.pipelineDetailsRow}>
                    <Col xs={12} className="mt-1 mb-1 d-flex flex-column ps-4">
                        <div className={styles.rowSubTitle}>Note</div>
                        <div className={styles.rowValues}>{props.noteData.note}</div>
                    </Col>
                </Row>
            </Container>
            <hr className={styles.dividerLine} />
            <Row className={styles.actionBtnRow}>
                <div className={styles.navigateBtnColSubmit}>
                    {<CustomButton
                        id="one_way_template_confirm"
                        buttonType="submit"
                        label="Submit"
                        type="primaryBtn"
                        disabled={props.submissionLoading ? true : false}
                        handleClick={() => props.submitNoteDetailsValues()}
                        backicon={props.submissionLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    />}

                </div>
                <div className={styles.navigateBtnCol}>
                    {<CustomButton
                        id="one_way_template_review_cancel"
                        buttonType="button"
                        label="Back"
                        type="secondaryBtn"
                        handleClick={() => props.previousPage(1)}

                    />}
                </div>
            </Row>

        </div>
    )
}

export default SpecialNoteReview;
